"use strict";
exports.__esModule = true;
exports.SvgColumnInfo = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgColumnInfo = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 14", fill: "none" }, props),
    react_1["default"].createElement("path", { d: "M7.401 4.25a1 1 0 01.958 1.288c-.964 3.214-1.457 4.884-1.48 5.01-.036.214-.036.317.053.415.09.098.23.182.418.08l.195-.086c.428-.19.928 0 1.122.426a1.03 1.03 0 01-.333 1.262l-.155.112c-.316.17-.569.243-.906.243-.473 0-.994-.053-1.39-.376-.68-.552-.989-1.39-.783-2.49.069-.368.475-1.7 1.219-3.996H5.86a.96.96 0 01-.96-.944.928.928 0 01.913-.944h1.588zM7.948 1a1 1 0 110 2 1 1 0 010-2z", fill: "currentColor" }))); };
//# sourceMappingURL=ColumnInfo.js.map